// @ts-nocheck

import { createSelector } from 'reselect';

import { type StateType } from '../../../states';

const emtpyObj = {};

export const selectGRGlobalState = createSelector(
  (state: StateType) => state.gr.global,
  (global) => global ?? emtpyObj,
);

export const selectGRGlobalVersion = createSelector(selectGRGlobalState, (global) => global.version);

export const selectGRGlobalStatus = createSelector(selectGRGlobalState, (global) => global.status);

export const selectGRGlobalEligibility = createSelector(
  selectGRGlobalState,
  (global) => global.eligibility ?? emtpyObj,
);

export const selectGRGlobalRaceId = createSelector(selectGRGlobalState, (global) => global.race);

export const selectGRGlobalStartDate = createSelector(selectGRGlobalState, (global) => global.operationStartDate);

export const selectGRGlobalEndDate = createSelector(selectGRGlobalState, (global) => global.operationEndDate);
